import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.6563 19.0711L11.9994 13.4142L6.34255 19.0711L4.92834 17.6569L10.5852 12L4.92834 6.34315L6.34255 4.92893L11.9994 10.5858L17.6563 4.92893L19.0705 6.34315L13.4136 12L19.0705 17.6569L17.6563 19.0711Z",
      fill: "black"
    }, null, -1)
  ])))
}
export default { render: render }